(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bacino-navigation"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',event=>{document.querySelectorAll('.bacino-shop-menu[open]').forEach(menu=>{if(!menu.contains(event.target))menu.open=false})});
document.addEventListener('keydown',event=>{if(event.key==='Escape'){document.querySelectorAll('.bacino-shop-menu[open]').forEach(menu=>{menu.open=false;menu.querySelector('summary').focus()})}});
  } catch(e) { console.error(e); }
})();

})();
